import { render } from "./ReportsList.vue?vue&type=template&id=0cbe869d"
import script from "./ReportsList.vue?vue&type=script&lang=js"
export * from "./ReportsList.vue?vue&type=script&lang=js"

import "./ReportsList.vue?vue&type=style&index=0&id=0cbe869d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__